import React, {useState, useEffect, useCallback} from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "./../App.css";
import "./Settings.css";
import { 
    /* setRootIPAddress, 
    setRootPort, 
    getIPAddress, 
    getPort,
    setRootIPAddressBiometrics, 
    setRootPortBiometrics, 
    getIPAddressBiometrics, 
    getPortBiometrics,
    setRootIPAddress2, 
    setRootPort2, 
    getIPAddress2, 
    getPort2,
    setRootIPAddressBiometrics2, 
    setRootPortBiometrics2, 
    getIPAddressBiometrics2, 
    getPortBiometrics2, */
    setRootTimeFormat,
    getTimeFormat
} from './Security';
import loadingSpinner from './../assets/loading.gif';
import axios from 'axios';
import {token, domain} from './Security';
// icons
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Settings({isHideSideMenu}) {
    /* const [ipAddress, setipAddress] = useState(getIPAddress);
    const [port, setPort] = useState(getPort);
    const [ipAddressBiometrics, setipAddressBiometrics] = useState(getIPAddressBiometrics);
    const [portBiometrics, setPortBiometrics] = useState(getPortBiometrics);
    const [ipAddress2, setipAddress2] = useState(getIPAddress2);
    const [port2, setPort2] = useState(getPort2);
    const [ipAddressBiometrics2, setipAddressBiometrics2] = useState(getIPAddressBiometrics2);
    const [portBiometrics2, setPortBiometrics2] = useState(getPortBiometrics2); */
    const [timeFormat, setTimeFormat] = useState(getTimeFormat);
    const [loading, setLoading] = useState(false);
    const [showConfirmationForm, setShowConfirmationForm] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [settings, setSettings] = useState([]);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const closeConfirmationFormClick = () =>{
        setShowConfirmationForm(false);
    }

    const fetchData = useCallback(async () => {
        const apiUrl = domain + "/api/Setting";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setSettings(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData])

    useEffect(() => {
        if(settings.length > 0){
            const _allowBeyond24HoursFiling = settings.find(i => i.description === "AllowBeyond24HoursFiling")

            if(_allowBeyond24HoursFiling?.value === "True"){
                setAllowBeyond24HoursFiling(true)
            } else if(_allowBeyond24HoursFiling?.value === "False"){
                setAllowBeyond24HoursFiling(false)
            }
        }
    }, [settings])

    const saveSettingHandler = async () =>{
        const apiUrl = domain + "/api/Setting/save-setting";

        const data = [
            {
                description: "AllowBeyond24HoursFiling",
                value: allowBeyond24HoursFiling ? "True" : "False"
            }
        ];

        try {
            setLoading(true);

            await axios.post(`${apiUrl}`, data, {
                headers: { 'Content-Type': 'application/json' }
            });
            
            setShowRequestMessage(true);
            setIsSuccess(true);
            setRequestMessage("Request successful")
        } catch (error) {
            console.error('There was a problem saving data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
        }
        closeConfirmationFormClick();
        setRootTimeFormat(timeFormat);
    }

    const handleSelectChange = (index) => {
        setSelectedTab(index);
    };

    const [allowBeyond24HoursFiling, setAllowBeyond24HoursFiling] = useState(false);

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                <div className="ReportsInfo">
                    <div className="reports-header">
                        <h3>Settings</h3>
                    </div>
                    <div className="reports-body">
                        <div className='loan-tab setting-tab hidden'>
                            <Tabs selectedIndex={selectedTab} onSelect={index => handleSelectChange(index)}>
                                <TabList>
                                    <Tab><b>Requests</b></Tab>
                                    {/* <Tab><b>Config 1</b></Tab>
                                    <Tab><b>Config 2</b></Tab> */}
                                    <Tab><b>Others</b></Tab>
                                </TabList>
                                <div className="loan-tabPanel">
                                    <TabPanel>
                                        <div className="setting-part flex flex-col gap-2">
                                            <span><b>Allow beyond 24 hours filing</b></span>
                                            <button
                                                type="button"
                                                onClick={() => setAllowBeyond24HoursFiling(!allowBeyond24HoursFiling)}
                                                className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                                                allowBeyond24HoursFiling ? "bg-green-500" : "bg-gray-400"
                                                }`}
                                            >
                                                <span
                                                className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                                                    allowBeyond24HoursFiling ? "translate-x-3" : "translate-x-[-10px]"
                                                }`}
                                                />
                                            </button>
                                        </div>
                                    </TabPanel>
                                    {/* <TabPanel>
                                        <div className="setting-part">
                                            <span><b>Web</b></span>
                                            <div className="info-item-holder row">
                                                <div className="info-item2 info-item column">
                                                    <div className="info-item-label">IP Address</div>
                                                    <div className="info-item-input">
                                                        <input
                                                        placeholder="IP Address"
                                                        value={ipAddress2}
                                                        onChange={(e) => setipAddress2(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="info-item2 info-item column">
                                                    <div className="info-item-label">Port</div>
                                                    <div className="info-item-input">
                                                        <input
                                                        placeholder="Port"
                                                        value={port2}
                                                        onChange={(e) => setPort2(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="setting-part">
                                            <span><b>Biometrics</b></span>
                                            <div className="info-item-holder row">
                                                <div className="info-item2 info-item column">
                                                    <div className="info-item-label">IP Address</div>
                                                    <div className="info-item-input">
                                                        <input
                                                        placeholder="IP Address"
                                                        value={ipAddressBiometrics2}
                                                        onChange={(e) => setipAddressBiometrics2(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="info-item2 info-item column">
                                                    <div className="info-item-label">Port</div>
                                                    <div className="info-item-input">
                                                        <input
                                                        placeholder="Port"
                                                        value={portBiometrics2}
                                                        onChange={(e) => setPortBiometrics2(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                        <div className="setting-part">
                                            <span><b>Web</b></span>
                                            <div className="info-item-holder row">
                                                <div className="info-item2 info-item column">
                                                    <div className="info-item-label">IP Address</div>
                                                    <div className="info-item-input">
                                                        <input
                                                        placeholder="IP Address"
                                                        value={ipAddress2}
                                                        onChange={(e) => setipAddress2(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="info-item2 info-item column">
                                                    <div className="info-item-label">Port</div>
                                                    <div className="info-item-input">
                                                        <input
                                                        placeholder="Port"
                                                        value={port2}
                                                        onChange={(e) => setPort2(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="setting-part">
                                            <span><b>Biometrics</b></span>
                                            <div className="info-item-holder row">
                                                <div className="info-item2 info-item column">
                                                    <div className="info-item-label">IP Address</div>
                                                    <div className="info-item-input">
                                                        <input
                                                        placeholder="IP Address"
                                                        value={ipAddressBiometrics2}
                                                        onChange={(e) => setipAddressBiometrics2(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="info-item2 info-item column">
                                                    <div className="info-item-label">Port</div>
                                                    <div className="info-item-input">
                                                        <input
                                                        placeholder="Port"
                                                        value={portBiometrics2}
                                                        onChange={(e) => setPortBiometrics2(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel> */}
                                    <TabPanel>
                                        <div className="setting-part">
                                            <span><b>Others</b></span>
                                            <div className="info-item-holder row">
                                                <div className="info-item3 info-item column">
                                                    <div className="info-item-label">Time Format</div>
                                                    <div className="info-item-input">
                                                        <TimeFormat timeFormat={timeFormat} setTimeFormat={setTimeFormat}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </div>
                            </Tabs>
                        </div>
                        <div className='loan-tab setting-tab'>
                            <div className="loan-tabPanel">
                                    <div className="setting-part flex flex-col gap-5">
                                        
                                        <div className="info-item-holder row">
                                            <div className="info-item3 info-item column">
                                                <div className="info-item-label">Time Format</div>
                                                <div className="info-item-input">
                                                    <TimeFormat timeFormat={timeFormat} setTimeFormat={setTimeFormat}/>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-2">
                                            <span><b>Allow beyond 24 hours filing</b></span>
                                            <button
                                                type="button"
                                                onClick={() => setAllowBeyond24HoursFiling(!allowBeyond24HoursFiling)}
                                                className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                                                allowBeyond24HoursFiling ? "bg-green-500" : "bg-gray-400"
                                                }`}
                                            >
                                                <span
                                                className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                                                    allowBeyond24HoursFiling ? "translate-x-3" : "translate-x-[-10px]"
                                                }`}
                                                />
                                            </button>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div className="reports-footer">
                        <div className="buttons row">
                            <button id="philhealthReportGenerate"
                                className="generate row" 
                                onClick={()=>setShowConfirmationForm(true)}
                                > SAVE SETTINGS
                            </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <ConfirmationForm  isOpen={showConfirmationForm} 
                    onClose={closeConfirmationFormClick}
                    handleSave={saveSettingHandler}
            >
            </ConfirmationForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>

            {loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    );
}

function TimeFormat({timeFormat, setTimeFormat}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setTimeFormat(event.target.value);
        setIsSelected(true);
    };

    const timeFormats = [
        "Standard Time", "Military Time"
    ];
    
    useEffect(() => {
        if(timeFormat !== "" && timeFormat !== 0 && timeFormat !== null && timeFormat !== undefined){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [timeFormat]);

    return (
        <div>
            <select id="monthSSSReport-select" value={timeFormat} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose a time format</option>
                {timeFormats.map((timeFormat, index) => (
                    <option key={index} value={timeFormat}>{timeFormat}</option>
                ))}
            </select>
        </div>
    );
};
function ConfirmationForm({isOpen, 
    onClose, 
    handleSave}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Confirmation!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to save this settings?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleSave}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export default Settings;
